import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Mounted inside the Router. Watches for the pendingLoginRedirect set
 * by GatedLink (when a logged-out user clicked a protected link). Once
 * the user signs in, this navigates them to the original target and
 * clears the pending state. Returns null — render-only side effect.
 */
const PostLoginRedirect: React.FC = () => {
  const { isAuthenticated, pendingLoginRedirect, clearPendingLoginRedirect } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && pendingLoginRedirect) {
      const target = pendingLoginRedirect;
      clearPendingLoginRedirect();
      navigate(target);
    }
  }, [isAuthenticated, pendingLoginRedirect, clearPendingLoginRedirect, navigate]);

  return null;
};

export default PostLoginRedirect;
